export const resourcesEnabled = (): boolean => import.meta.env.VITE_RESOURCES_ENABLED === "true";
